import { useMemo } from 'react';
import { useFrame, useLoader } from '@react-three/fiber';
import * as THREE from 'three';

const TEX = {
  full: ['earth_day.jpg', 'earth_clouds.png', 'earth_normal.jpg', 'earth_specular.jpg'],
  lite: ['earth_day_1k.jpg', 'earth_clouds_1k.png', 'earth_normal_1k.jpg', 'earth_specular_1k.jpg'],
};

// Sfera con texture satellitari NASA + layer nuvole. rotate=false quando il parent applica già GLOBE_EULER.
export default function Earth({ radius = 1, autoRotate = true, earthRef, cloudsRef, lite = false, rotate = true, segments = 96 }) {
  const [day, clouds, normal, specular] = useLoader(
    THREE.TextureLoader,
    TEX[lite ? 'lite' : 'full'].map(f => `/textures/earth/${f}`),
  );

  useMemo(() => {
    [day, clouds, normal, specular].forEach(t => {
      t.anisotropy = lite ? 4 : 8;
      t.wrapS = t.wrapT = THREE.RepeatWrapping;
    });
    day.colorSpace = THREE.SRGBColorSpace;
  }, [day, clouds, normal, specular, lite]);

  const rot = rotate ? [0, THREE.MathUtils.degToRad(-102.5), THREE.MathUtils.degToRad(-12)] : [0, 0, 0];

  useFrame((_, delta) => {
    if (autoRotate && cloudsRef?.current) cloudsRef.current.rotation.y += delta * 0.015;
  });

  return (
    <>
      <mesh ref={earthRef} rotation={rot}>
        <sphereGeometry args={[radius, segments, segments]} />
        <meshPhongMaterial
          map={day}
          normalMap={normal}
          normalScale={new THREE.Vector2(0.75, 0.75)}
          specularMap={specular}
          specular={new THREE.Color('#2a4a6a')}
          shininess={14}
        />
      </mesh>
      <mesh ref={cloudsRef} rotation={rot} raycast={() => null}>
        <sphereGeometry args={[radius * 1.008, 64, 64]} />
        <meshPhongMaterial map={clouds} transparent opacity={0.32} depthWrite={false} />
      </mesh>
    </>
  );
}
